import { observer } from 'mobx-react-lite'
import React from 'react'
import { Box, Icon, Typography } from 'shared/ui'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import type { ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { RingStore } from '../../store/RingStore'

export const RingNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof RingStore)) return null

  const { ringFirstDropdownStore, duration } = store

  return (
    <SmartCallActionNode
      iconProps={RingStore.iconProps}
      title={RingStore.title}
      placeholder={'Configure'}
      content={
        ringFirstDropdownStore.activeItem ? (
          <Typography ariaLabel={'info'} variant={'body-md-regular'}>
            <Box display={'flex'} gap={0.5}>
              {ringFirstDropdownStore.activeItem?.iconL && (
                <Icon icon={ringFirstDropdownStore.activeItem?.iconL} />
              )}
              {ringFirstDropdownStore.activeItem.label} for {duration} seconds
            </Box>
          </Typography>
        ) : null
      }
      {...props}
    />
  )
})
